import { useNavigate } from "react-router-dom";
import { Settings, ShoppingBasket } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_60566f20-32da-458f-94ff-7bee79b2ab60/artifacts/dzka9ng8_Munch%27d%20Logo.png";

export default function Header({ basketCount = 0, basketTotal = 0, onBasketClick }) {
  const navigate = useNavigate();

  return (
    <header className="bg-[#1aa59a] sticky top-0 z-40 shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex items-center">
          <img 
            src={LOGO_URL} 
            alt="Munch'd Meals" 
            className="h-10 sm:h-11 w-auto object-contain"
          />
        </div>
        
        <div className="flex items-center gap-2">
          {/* Basket Button - Always visible in header */}
          {basketCount > 0 && (
            <button
              onClick={onBasketClick}
              className="flex items-center gap-2 bg-white text-[#1aa59a] px-3 py-1.5 rounded-full shadow-sm hover:shadow-md transition-all"
              data-testid="basket-button"
            >
              <div className="relative">
                <ShoppingBasket className="w-5 h-5" />
                <span className="absolute -top-1.5 -right-1.5 bg-[#1aa59a] text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
                  {basketCount}
                </span>
              </div>
              <span className="font-bold text-sm">£{basketTotal.toFixed(2)}</span>
            </button>
          )}
          
          {/* Admin Button */}
          <button
            onClick={() => navigate("/admin")}
            className="flex items-center justify-center bg-white/10 hover:bg-white/20 text-white p-2 rounded-lg transition-colors"
            data-testid="admin-button"
          >
            <Settings className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
}
